import React from 'react'
import { makeStyles } from '@material-ui/styles'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'

const useStyles = makeStyles(theme => ({
  condition: {
    fontSize: 13,
    borderRadius: 5,
    backgroundColor: '#E1E5FE',
    padding: '4px 8px 4px 8px'
  }
}))

const ConditionDetails = ({ conditionDetails }) => {
  const classes = useStyles()

  return (
    <DazzedParagraph12 strong className={classes.condition}>
      {conditionDetails}
    </DazzedParagraph12>
  )
}

export default ConditionDetails
